import React from 'react';
import PropTypes from 'prop-types';

import styles from '../../../../utils/styles';
import './typography-elements.scss';

export interface ITypographyElements {
  text: string;
  typographyClass: string;
  className?: string[];
}

const TypographyElements: React.FC<ITypographyElements> = ({ text = '', typographyClass = '', className = [] }) => (
  <p className={styles(typographyClass, ...className)}>{text}</p>
);

TypographyElements.propTypes = {
  text: PropTypes.string.isRequired,
  typographyClass: PropTypes.string.isRequired,
};

export default TypographyElements;
